import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'budget',
    pathMatch: 'full',
  },
  {
    path: 'budget',
    loadChildren: () => import('@suitelifetools/budgeting').then((m) => m.BUDGETING_ROUTES),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./pages/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/terms-of-service.component').then((m) => m.TermsOfServiceComponent),
  },
  {
    path: '**',
    redirectTo: 'budget',
  },
];
